import { Toaster } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/toast/Toaster.tsx";
import { UiTextProvider } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/i18n.tsx";
import { type ReactNode, useCallback } from "react";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

import { reportUnknownEnum } from "../lib/enums";
import { OfflineBanner } from "../offline/OfflineBanner";

/**
 * Chrome shared by the app root route and the lean public entry (`src/public/main.tsx`): the UI
 * kit's text provider (FE-02 FR-FE02-21), the offline banner and the single toast region
 * (FR-FE01-28). It uses no router, so the public pages can render without one (NFR-FE01-01).
 */
export function AppProviders({
  children,
  aboveBottomNav = false,
}: {
  children: ReactNode;
  aboveBottomNav?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  // UI kit components read `ui:` keys and enum labels through the app's i18n.
  const uiT = useCallback(
    (key: string, values?: Record<string, unknown>) =>
      i18n.t(key as never, { ...values, lng: lang } as never) as unknown as string,
    [i18n, lang],
  );
  const uiExists = useCallback((key: string) => i18n.exists(key, { lng: lang }), [i18n, lang]);
  return (
    <UiTextProvider t={uiT} exists={uiExists} onUnknownValue={reportUnknownEnum}>
      <OfflineBanner />
      {children}
      <Toaster
        dismissLabel={t("toast.dismiss")}
        regionLabel={t("toast.region")}
        aboveBottomNav={aboveBottomNav}
      />
    </UiTextProvider>
  );
}
